import React from "react";
import { Box } from "@mui/material";
import DeleteModal from "./DeleteModal";
import { deleteCritiques } from "../../../pages/critique/critique.service";
import { handleApiError } from "../../../Utils/errorHandler";

/**
 * Confirm + delete one or more critiques (TPX-2730).
 * critiques: [{ id, title, propertyName }]. State (open/close) is owned by the parent.
 * onDeleted(ids) runs after a successful delete; on failure the dialog stays open.
 */
const DeleteCritiqueDialog = ({ open, onClose, critiques = [], onDeleted, showToast }) => {
  const isSingle = critiques.length === 1;
  const first = critiques[0];

  const handleSubmit = async () => {
    const ids = critiques.map((c) => c.id);
    try {
      await deleteCritiques(ids);
      showToast?.(isSingle ? "Critique deleted" : `${ids.length} critiques deleted`, "success");
      onDeleted?.(ids);
    } catch (err) {
      handleApiError(err, showToast, "Failed to delete critique");
      throw err;
    }
  };

  if (!open || critiques.length === 0) return null;

  return (
    <DeleteModal
      isOpen={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      preventBackdropClose
      title={isSingle ? `Delete ${first.title || "Untitled Critique"}?` : `Delete ${critiques.length} critiques?`}
      message={
        isSingle
          ? "This critique will be deleted. Future critiques from its template will still be created on schedule."
          : "These critiques will be deleted. Future critiques from their templates will still be created on schedule."
      }
      itemLabel={isSingle ? "Property:" : undefined}
      itemValue={isSingle ? first.propertyName : undefined}
      details={
        isSingle ? null : (
          <Box component="ul" sx={{ mt: 1, pl: 3, maxHeight: 240, overflowY: "auto", fontSize: "14px", lineHeight: "22px" }}>
            {critiques.map((c) => (
              <li key={c.id}>
                <strong>{c.title || "Untitled Critique"}</strong> — {c.propertyName}
              </li>
            ))}
          </Box>
        )
      }
      cancelLabel="No, don't delete"
      confirmLabel="Yes, delete"
    />
  );
};

export default DeleteCritiqueDialog;
